import { trackToolClick } from '../../../lib/trackToolClick';
import { relativeTime } from '../../../lib/relativeTime';
import { ToolIcon } from './ToolTile';

export default function RecentTools({ items }) {
  if (items.length === 0) return null;
  return (
    <section className="home-section" aria-labelledby="home-recent-h">
      <h2 id="home-recent-h" className="home-section__title">Recently used</h2>
      <ul className="home-chips">
        {items.map(({ tool, lastUsedAt }) => (
          <li key={tool.id}>
            <a className="home-chip" href={tool.link} target="_blank" rel="noopener noreferrer" onClick={() => trackToolClick(tool.id)}>
              <span className="home-chip__icon">
                <ToolIcon tool={tool} />
              </span>
              <span className="home-chip__name">{tool.name}</span>
              <span className="home-chip__time">{relativeTime(lastUsedAt)}</span>
            </a>
          </li>
        ))}
      </ul>
    </section>
  );
}
